import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import ActionIconButton from '../common/ActionIconButton';

const DeleteButton = ({ onDelete, item="" }) => {
    return (
        <ActionIconButton
            title="Delete"
            onClick={() => onDelete(item)}
            icon={<DeleteIcon fontSize="small" />}
        />
    );
};

export default DeleteButton;
